// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__12I_k","gfeWrapper":"CalendarEvent_gfeWrapper__1DcDh"};